module.exports = __webpack_public_path__ + "images/visibility-gains-ef587916.svg";